export function Array_lastOrDefault<T>(array: T[]): T | null {
    if (array.length === 0) {
        return null;
    }

    const last = array[array.length - 1];
    return last;
}

export function Array_sum(array: number[]): number {
    return array.reduce((a, b) => a + b, 0);
}

export function Array_unorderedEquals<T>(array1: T[], array2: T[], comparer?: (a: T, b: T) => boolean): boolean {
    if (array1.length !== array2.length) {
        return false;
    }

    comparer = comparer ?? ((a, b) => a === b);

    for (const item1 of array1) {
        if (!array2.some(item2 => comparer!(item1, item2))) {
            return false;
        }
    }

    for (const item2 of array2) {
        if (!array1.some(item1 => comparer!(item1, item2))) {
            return false;
        }
    }

    return true;
}